(function (window, document, $) {
    'use strict';

    // $(function() {
    //     $('.table-content:nth-child(-n+4)').addClass('active');
    //     $('a.btn-show-more').on('click', function(e) {
    //         e.preventDefault();
    //         $(this).closest('div').parent().find('table .table-content').addClass('active');
    //         // hide the button when all elements visible
    //         $(this).addClass('overlay-none');
    //         $(this).hide();
    //     });
    //
    // });

    $(function () {
        const $relatedHeader = $('.related-posts .box-head')

        if ($relatedHeader.eq(0).height() !== $relatedHeader.eq(1).height()) {
            $relatedHeader.css('min-height', '60px');
        } else {
            $relatedHeader.css('min-height', '30px');
        }
    });
}(window, document, jQuery));